<div class="reset">
  <div class="col-12">
    <label for="reset-token" class="visually-hidden">Reset token</label>
    <input
      id="reset-token"
      type="text"
      placeholder="Reset token"
      class="input-text"
      [(ngModel)]="resetToken"
    />
    <label for="password" class="visually-hidden">Password</label>
    <input
      id="password"
      type="password"
      placeholder="Password"
      class="input-text"
      [(ngModel)]="password"
    />
    <label for="confirm" class="visually-hidden">Confirm password</label>
    <input
      id="confirm"
      type="password"
      placeholder="Confirm password"
      class="input-text"
      [(ngModel)]="confirm"
    />
    <button class="button primary" (click)="resetPassword()">
      Reset password
    </button>
  </div>
  <mat-progress-bar
    [class.visually-hidden]="!(loading$ | async)"
    class="top-loading-bar"
    mode="indeterminate"
  ></mat-progress-bar>
</div>
